import axios from 'axios';

export const isRestaurantOperatingContext = (groupId: string | null | undefined): boolean =>
  !!groupId && groupId !== 'all';

export const getArchiveRebuildUnavailableNotice = (groupId: string | null): string | null => {
  if (isRestaurantOperatingContext(groupId))
    return 'Архів збережено; перебудова історії в режимі ресторану недоступна.';
  if (groupId === 'all')
    return 'Архів збережено. Перебудову історії не виконано: режим огляду всіх груп доступний лише для читання.';
  return null;
};

export const getHistoricalWriteOffUnavailableNotice = (
  groupId: string | null,
  changedInAnotherTab = false,
  ready = true,
): string | null => {
  if (changedInAnotherTab)
    return 'Робочу групу змінено в іншій вкладці. Оновіть сторінку, щоб продовжити.';
  if (!ready)
    return 'Операційний контекст не підтверджено. Масові операції з історичними списаннями недоступні.';
  if (isRestaurantOperatingContext(groupId))
    return 'Масові операції з історичними списаннями недоступні в контексті операційної групи.';
  if (groupId === 'all')
    return 'Огляд усіх груп доступний лише для читання; масові операції з історичними списаннями недоступні.';
  return null;
};

export const contextError = (error: unknown) =>
  axios.isAxiosError<{ message?: string }>(error) && error.response?.data?.message
    ? error.response.data.message
    : 'Не вдалося завантажити контекст. Оновіть дані перед продовженням.';
